
import { defineComponent } from "vue";
import "./index.css";
import SiteNavbar from "@/components/SiteNavbar.vue";

export default defineComponent({
  name: "App",
  components: { SiteNavbar },
  data() {
    return {
      sortedData: "",
      fileName: "",
      showData: false,
      showAlert: false
    };
  },
  methods: {
    onChange(event: InputEvent) {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];

      if (!file) return;

      this.fileName = file.name;
      file.text().then((data: string) => {
        this.processData(data);
      });
    },
    processData(data: string) {
      const sortedLines = data
        .split(/\r\n|\r|\n/g)
        .sort(function (a: string, b: string) {
          let aSp = a.split("-");
          let bSp = b.split("-");

          if (aSp.length == 2 && bSp.length == 2 && aSp[0] !== bSp[0])
            return a.localeCompare(b);

          return parseInt(aSp[1]) < parseInt(bSp[1]) ? 1 : -1;
        });
      this.sortedData = sortedLines.join("\n");
    },
    downloadFile() {
      const blob = new Blob([this.sortedData], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = this.fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    },
    copy() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.sortedData);
      }
    },
    doCopy() {
      this.copy();
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 2000);
    }
  },
  computed: {
    sortedForHtml(): string {
      return this.sortedData.replaceAll("\n", "<br />");
    }
  }
});
